import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '10vh',
    margin: '0 100px',
    backgroundColor: 'transparent',
  },
  logostyle: {
    width: '140px',
    height: '52px',
  },
  uploadLogo: {
    marginTop: '50px',
    width: '100px',
  },
  uploadLogoPic: {
    '& img': {
      display: 'flex',
      alignItems: 'center',
      width: '60px',
      height: '60px',
    },
    marginTop: '30px',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: '#FFF',
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    float: 'right',
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    marginTop: '50px',
  },
}));
